import api from '../utils/axiosConfig';

export interface MitreSyncStatus {
  synced: boolean;
  attack_version: string | null;
  technique_count: number | null;
  last_synced_at: string | null;
  status: 'ok' | 'error' | null;
  error_message: string | null;
  duration_ms: number | null;
}

export interface MitreSyncResult {
  version: string;
  technique_count: number;
  duration_ms: number;
}

export class AdminService {
  static async getMitreStatus(): Promise<MitreSyncStatus> {
    const res = await api.get('/admin/mitre/status');
    return res.data;
  }

  static async triggerMitreSync(): Promise<MitreSyncResult> {
    const res = await api.post('/admin/mitre/sync');
    return res.data;
  }
}